import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { REPOSITORY_BASE_URL_TOKEN, RepositoryBaseUrlConfigFactory } from './services';

export function provideShared(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: REPOSITORY_BASE_URL_TOKEN,
            useFactory: RepositoryBaseUrlConfigFactory,
        },
    ]);
}
